package org.example.project.firebase

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.initialize

object FirebaseInitializer {

    fun initialize() {

        Firebase.initialize(

            options = FirebaseOptions(

                applicationId =
                    FirebaseConfig.APP_ID,

                apiKey =
                    FirebaseConfig.API_KEY,

                projectId =
                    FirebaseConfig.PROJECT_ID,

                storageBucket =
                    FirebaseConfig.STORAGE_BUCKET,

                gcmSenderId =
                    FirebaseConfig.MESSAGING_SENDER_ID,

                authDomain =
                    FirebaseConfig.AUTH_DOMAIN
            )
        )

        // Initialize Auth explicitly
        Firebase.auth
        
        println("Firebase initialized")
    }
}